<template>
  <div class="auto-reg">
    <HeroBlock v-bind="hero"></HeroBlock>
    <div class="block">
      <CardBlock :cards="cards"></CardBlock>
      <DescriptionBlock v-bind="description"></DescriptionBlock>
      <LikeBlock v-bind="like"></LikeBlock>
    </div>
    <Toggle :cards="cards" :description="description" :like="like"></Toggle>
    <AutoDemo></AutoDemo>
    <ManiaBlock></ManiaBlock>
    <Calculator></Calculator>
  </div>
</template>

<script>
import HeroBlock from "@/components/hero-block";
import CardBlock from "@/components/cards-block";
import DescriptionBlock from "@/components/description-block";
import LikeBlock from "@/components/like-block";
import Toggle from "@/components/toggle";
import AutoDemo from "@/components/auto-demo";
import ManiaBlock from "@/components/mania";
import Calculator from "@/components/auto-calculator";
export default {
  components: {
    HeroBlock,
    CardBlock,
    DescriptionBlock,
    LikeBlock,
    Toggle,
    AutoDemo,
    Calculator,
    ManiaBlock
  },
  data() {
    return {
      hero: {
        title: `Автоматизированная стойка регистрации`,
        paragraphs: [
          `Удобный сервис анкетирования и регистрации чеков участников стимулирующих акций.`,
          `Продукт включает в себя программу для быстрого ввода персональных данных, систему <br> 
          умного распознавания чеков и отчеты с подробной статистикой.`,
          `Система проста в использовании, интуитивно понятна и не требует наличия у персонала <br>
          специальных навыков. 
          Для работы необходимы компьютер с выходом в интернет, сканер <br> 
          QR-кодов и принтер.`,
          `Запуск регистрации возможен уже через 3 дня с момента  согласования правил акции. `
        ],
        src: require(`@/assets/images/hero1.png`)
      },
      cards: [
        {
          title: `Распознает чеки`,
          paragraph: `При сканировании QR-кода система мгновенно получает полную информацию из чека. программа наполняет статистику <br> 
          данными о сумме, месте и времени совершения покупки. Сервис проверяет подлинность чеков, суммирует или дробит <br> 
          их и рассчитывает необходимое количество купонов или призов к выдаче. Регистратор больше не несет ответственность <br>
          за проверку чеков и математические расчеты - всю работу за доли секунды делает программа.`,
          src: require(`@/assets/images/card1.svg`)
        },
        {
          title: `Анкетирует участников`,
          paragraph: `Для опроса участников акции составляется анкета из любых вопросов. Настройка каждого пункта анкеты очень <br>
          гибкая, поля ввода проверяются на лету и не позволяют регистратору сделать ошибку. Ввести несуществующую <br>
          дату рождения, или email теперь нельзя. Система, если это возможно, заполнит поле автоматически при вводе <br>
          первых букв, например, когда необходимо узнать место жительства участника, <br>
          или марку его автомобиля.`,
          src: require(`@/assets/images/card2.svg`)
        },
        {
          title: `Работает сверхбыстро`,
          paragraph: `Полная регистрация участника в акции занимает не более 40 секунд. Благодаря отточенному интерфейсу и мгновенному <br>
          сканированию чека, даже объемные анкеты заполняются очень быстро. Для уже зарегистрированных пользователей после <br>
          ввода номера телефона все поля анкеты заполняются автоматически, и регистрация покупок длится не более 15 секунд.`,
          src: require(`@/assets/images/card3.svg`)
        },
        {
          title: `Защищает от мошенников`,
          paragraph: `Система исключает подделку чеков и не допускает ошибок регистраторов. Сведения о покупках сверяются <br>
          с данными ФНС, а заполненные с ошибкой поля подсвечиваются и не позволяют закончить регистрацию. <br>
          Программа сообщает о регистрации чеков из неучтенных кассовых аппаратов и появлении в ТРЦ неизвестных <br>
          юридических лиц, что помогает выявить ряд схем сокрытия выручки арендаторами.`,
          src: require(`@/assets/images/card4.svg`)
        }
      ],
      description: {
        title: `Ведет статистику On-line`,
        paragraphs: [
          `Система собирает данные и организует их в количественные  и качественные <br>
          статистические отчеты. Отчеты формируются из анкет пользователей и полной <br>
          истории их покупок.`,
          `Программа вычисляет распространенные маркетинговые показатели, такие <br>
          как средний чек, или коэффициент удержания клиентов.`,
          `Cтатистика представлена в удобном видe и сортируется по любым данным. <br>
          Доступно добавление специальных отчетов и скачивание данных в excel.`
        ],
        src: require(`@/assets/images/description1.svg`)
      },
      like: {
        title: `Отвечает за персональные данные`,
        paragraph: `Программа действует в полном соответствии законодательству России. EventGO! несет ответственность за сбор, хранение и обработку персональных данных <br>
        и осуществляет сбор соответствующих согласий клиентов. Все получаемые сведения передаются по зашифрованным каналам связи <br>
        и хранятся в защищенных хранилищах с контролируемым доступом.`,
        src: require(`@/assets/images/like1.svg`)
      }
    };
  }
};
</script>
